export const NAMESPACE = 'experiments';
export const EXPERIMENT_ASSIGNMENT = 'experiment_assignment';
export const EXPERIMENT_CONTROL_ID = 'control';

export enum EXPERIMENT_NAMES {
  ARTICLE_SIGNUP_COPY = 'articleSignupCopy',
}
